import * as region from 'common/constants/region-codes';

export const WINDOWS_BRANDS_SELECTION_GROUP_OPTION_LIST = [
  { value: 'deceuninck', text: 'Deceuninck' },
  { value: 'rehau', text: 'РЕХАУ' },
];

export const REHAU_BRAND_REGION_LIST = [
  region.IRKUTSK,
  region.PETROZAVODSK,
  region.PSKOV,
  region.ST_PETERSBURG,
  region.STAVROPOL,
  region.KAZAKHSTAN,
];

export const VEKA_BRAND_REGION_LIST = [
  region.ARKHANGELSK,
  region.BARNAUL,
  region.EKATERINBURG,
  region.IVANOVO,
  region.IZHEVSK,
  region.KAZAN,
  region.KALUGA,
  region.KEMEROVO,
  region.KIROV,
  region.KOSTROMA,
  region.KRASNOYARSK,
  region.MOSCOW,
  region.NABEREZHNYE_CHELNY,
  region.N_NOVGOROD,
  region.NOVOKUZNETSK,
  region.NOVOSIBIRSK,
  region.ORENBURG,
  region.PENZA,
  region.PERM,
  region.RYAZAN,
  region.SAMARA,
  region.SARANSK,
  region.SARATOV,
  region.SMOLENSK,
  region.SURGUT,
  region.TVER,
  region.TOLYATTI,
  region.TULA,
  region.TYUMEN,
  region.ULYANOVSK,
  region.UFA,
  region.KHABAROVSK,
  region.CHELYABINSK,
  region.CHEREPOVETS,
  region.YAROSLAVL,
];

export const DECEUNINCK_BRAND_REGION_LIST = [region.VORONEZH, region.KURSK, region.LIPETSK];

export const REHAU_AND_DECEUNINCK_BRAND_REGION_LIST = [
  region.VLADIKAVKAZ,
  region.VOLGOGRAD,
  region.KRASNODAR,
  region.NOVOROSSIYSK,
  region.ROSTOV_NA_DONU,
  region.KAZAKHSTAN,
];
